import React, { FC } from 'react';
import { ControlledInput, FormGrid, Section } from '../../../shared';
import { useTranslation } from 'react-i18next';

export const OrganisationAddressInputs: FC = () => {
    const { t } = useTranslation();

    return (
        <Section title={t('addressLabel')}>
            <FormGrid size={{ xs: 2 }}>
                <ControlledInput name="address.street" label={t('streetLabel')} />
                <ControlledInput name="address.number" label={t('numberLabel')} />
                <ControlledInput name="address.box" label={t('boxLabel')} />
                <ControlledInput name="address.postalCode" label={t('postalCodeLabel')} />
                <ControlledInput name="address.city" label={t('cityLabel')} />
                <ControlledInput name="address.country" label={t('countryLabel')} />
            </FormGrid>
        </Section>
    );
};
